import React from 'react';

// Shared Terms & Conditions body. Used both in the Loyalty page modal
// and on the standalone /terms page so wording stays in sync.
// NOTE: These are placeholder terms. Replace with final legal copy before launch.
export default function TermsContent() {
  return (
    <div className="space-y-5 text-sm leading-relaxed text-gray-300" data-testid="terms-content">
      <section>
        <h3 className="text-white font-semibold mb-1">1. Introduction</h3>
        <p>
          Welcome to the Promote Black Business (PBB) Loyalty Program. By enrolling,
          scanning a merchant QR code, or redeeming any reward, you agree to be bound by
          these Terms &amp; Conditions along with our general Terms of Service and Privacy
          Policy. If you do not agree, please do not use the program.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">2. Eligibility</h3>
        <p>
          The program is open to individuals who are at least 13 years old and hold an
          active PBB account. Business owners may only issue stamps or rewards for their
          own verified listings.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">3. Earning Points &amp; Stamps</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li>Points are awarded for eligible activity (purchases, RSVPs, coupon redemptions, QR check-ins).</li>
          <li>Each business stamp card is limited to <b>one stamp per 24 hours</b> per user, per business.</li>
          <li>Fraudulent stamps, purchases, or referrals may be reversed at any time.</li>
        </ul>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">4. Redemption</h3>
        <p>
          Rewards are redeemable in-store at the issuing business (for stamp cards) or
          within PBB (for platform rewards). Redemption codes are single-use and expire
          per the merchant's stated window. PBB is not the seller of merchant rewards and
          cannot guarantee availability of any specific product or service.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">5. Expiration &amp; Forfeiture</h3>
        <p>
          Points may expire after 12 months of account inactivity. Stamps may be voided if
          the underlying loyalty program is discontinued by the merchant. Accounts closed
          for policy violations forfeit all unredeemed points and rewards.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">6. No Cash Value</h3>
        <p>
          Points, stamps, and rewards have no cash value, are non-transferable, and cannot
          be sold, gifted, or exchanged outside of the features PBB provides.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">7. Changes to the Program</h3>
        <p>
          PBB may modify, suspend, or terminate the loyalty program (or any part of it) at
          any time, with or without notice. Material changes will be posted on this page.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">8. Contact</h3>
        <p>
          Questions about these terms can be sent to <a className="text-green-400 hover:underline" href="mailto:support@pbb.app">support@pbb.app</a>.
        </p>
      </section>

      <p className="text-xs text-gray-500 pt-2 border-t border-[#153b23]">
        Last updated: February 2026 · These placeholder terms will be replaced with the
        finalized legal language prior to public launch.
      </p>
    </div>
  );
}
